<script>
  import { Swiper } from "swiper";
  import { Navigation, Pagination, EffectCards } from "swiper/modules";
  import "swiper/css";
  import "swiper/css/effect-cards";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import { onMount } from "svelte";

  export let slides = [];

  let swiper;
  let swiperInitialized = false;

  $: swiperParams = {
    modules: [Navigation, Pagination, EffectCards],
    effect: "cards",
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  };

  onMount(() => {
    try {
      swiper = new Swiper(".mySwiper", swiperParams);
      swiperInitialized = true;
    } catch (error) {
      console.error("Error initializing Swiper:", error);
    }
    return () => {
      if (swiperInitialized) swiper.destroy();
    };
  });
</script>

<div class="swiper mySwiper">
  <div class="swiper-wrapper">
    {#each slides as slide}
      <div class="swiper-slide">
        <img src={slide.image} alt={slide.title} />
      </div>
    {/each}
  </div>
  <div class="swiper-pagination"></div>
</div>

<style>
  .mySwiper {
    width: 600px;
    height: 910px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 20px;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 10px;
  }

  .swiper-slide img {
    object-fit: cover; /* Maintain aspect ratio and cover the container */
    border-radius: 10px 10px 0 0;
    width: 100%; /*This ensures the image takes the full width*/
    height: 100%; /*This ensures the image takes the full height*/
  }

  .swiper-pagination {
    position: relative;
    margin-top: 20px;
  }

  :global(.swiper-pagination-bullet) {
    width: 10px;
    height: 10px;
    background-color: #4f7942;
  }

  @media (min-width: 961px) {
    .mySwiper {
      width: 600px;
      height: 910px;
    }
  }
  @media (max-width: 480px) {
    .mySwiper {
      width: 80%;
      height: 80%;
    }
  }
  @media (min-width: 481px) and (max-width: 960px) {
    .mySwiper {
      width: 80%;
      height: 80%;
    }
  }
</style>
